module.exports = __webpack_public_path__ + "img/home-s3-img2.b991fdbc.svg";